import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import * as formik from 'formik';
import { FieldArray, Field, ErrorMessage } from 'formik';
import InputMask from 'react-input-mask';
import CreatableSelect from 'react-select/creatable';
import Select from 'react-select';
import Swal from 'sweetalert2';
import axiosClient from '../../../../config/axios.js';

function RoadsideAssistancesFields({ handleSubmit, handleChange, handleBlur, values, touched, errors, setFieldValue, setFieldTouched }) {

    const [selectedOptions, setSelectedOptions] = useState([]);

 
    return (
        <>
            <Row className="mb-3">
                <Form.Group as={Col} md="12" >
                    <Form.Label>Nombre de la Asistencia vial</Form.Label>
                    <Form.Control
                        type="text"
                        name="roadsideAssistance_name"
                        placeholder="Nombre de la Asistencia vial"
                        value={values.roadsideAssistance_name}
                        onChange={handleChange}
                        isInvalid={!!errors.roadsideAssistance_name}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors.roadsideAssistance_name}
                    </Form.Control.Feedback>
                </Form.Group>
            </Row>

            <FieldArray
                name="roadsideAssistanceContacts"
                render={arrayHelpers => {

                    return (
                        <>

                            <Row className='mb-4'>
                                <div className="row">
                                    <div className="col-md-12">

                                        <Link to='#'
                                            className="btn btn-success btn-rounded px-4 rounded-pill float-end"
                                            onClick={() =>
                                                arrayHelpers.push({
                                                    name: "",
                                                    position: "",
                                                    phone: "",
                                                    phone_extension: ""
                                                })
                                            }
                                        >
                                            <i className="fa fa-plus fa-lg me-2 ms-n2 text-success-900"></i> Agregar Contacto
                                        </Link>
                                    </div>
                                </div>
                                <div className="table-responsive">
                                    <table className="table table-invoice">
                                        <thead>
                                            <tr>
                                                <th width="40%">Nombre completo</th>
                                                <th width="30%">Puesto</th>
                                                <th width="15%">Teléfono</th>
                                                <th width="10%">Extensión</th>
                                                <th width="5%">Eliminar</th>
                                            </tr>
                                        </thead>
                                        <tbody>

                                            {values.roadsideAssistanceContacts && values.roadsideAssistanceContacts.length > 0
                                                ? values.roadsideAssistanceContacts.map((roadsideAssistanceContact, index) => (
                                                    <tr key={index}>
                                                        <td>
                                                            <span className="text-dark">
                                                                <Field
                                                                    placeholder="Nombre completo"
                                                                    className="form-control"
                                                                    name={`roadsideAssistanceContacts.${index}.name`}
                                                                    autoComplete="off"
                                                                />
                                                            </span>
                                                            <span className='invalid-feedback' style={{ display: 'block' }}>
                                                                <ErrorMessage name={`roadsideAssistanceContacts.${index}.name`} />
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <span className="text-dark">
                                                                <Field
                                                                    placeholder="Puesto"
                                                                    className="form-control"
                                                                    name={`roadsideAssistanceContacts.${index}.position`}
                                                                    autoComplete="off"
                                                                />
                                                            </span>
                                                            <span className='invalid-feedback' style={{ display: 'block' }}>
                                                                <ErrorMessage name={`roadsideAssistanceContacts.${index}.position`} />
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <span className="text-dark">
                                                                <InputMask
                                                                    name={`roadsideAssistanceContacts.${index}.phone`}
                                                                    mask="(999) 999-9999"
                                                                    className="form-control"
                                                                    placeholder="(999) 999-9999"
                                                                    value={values.roadsideAssistanceContacts[index].phone}
                                                                    onChange={(e) => {
                                                                       // console.log(e.target.value);
                                                                        setFieldValue(`roadsideAssistanceContacts.${index}.phone`, e.target.value);
                                                                    }}
                                                                />
                                                            </span>
                                                            <span className='invalid-feedback' style={{ display: 'block' }}>
                                                                <ErrorMessage name={`roadsideAssistanceContacts.${index}.phone`} />
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <span className="text-dark">
                                                                <Field
                                                                    placeholder="Extensión"
                                                                    className="form-control"
                                                                    name={`roadsideAssistanceContacts.${index}.phone_extension`}
                                                                    autoComplete="off"
                                                                />
                                                            </span>
                                                            <span className='invalid-feedback' style={{ display: 'block' }}>
                                                                <ErrorMessage name={`roadsideAssistanceContacts.${index}.phone_extension`} />
                                                            </span>
                                                        </td>

                                                        <td>
                                                            <button
                                                                type="button"
                                                                className="btn btn-danger"
                                                                onClick={() => {
                                                                    arrayHelpers.remove(index); // Elimina la fila del FieldArray
                                                                }}
                                                            >
                                                                <span className='fa fa-trash' />
                                                            </button>
                                                        </td>

                                                    </tr>
                                                ))
                                                : null
                                            }

                                        </tbody>
                                    </table>
                                </div>
                            </Row>
                        </>
                    );
                }}
            />

        </>
    );
};

export default RoadsideAssistancesFields;